/**
* Treatment Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatment Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'treatment-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const text = '.js-treatment-hero-text';
      const lines = '.js-treatment-hero-lines';
      const images = '.js-treatment-hero-images';
      const cards = '.js-treatment-hero-cards';

      const basicFade = {
        autoAlpha: 1, // property/value
        duration: 0.35, // duration e.g. 0.35s
        ease: '0.25,0.1,0.25,1', // timing function e.g. ease
        stagger: 0.1, // delay e.g 0.1s
      };

      const basicSlideUp = {
        y: 0, // property/value
        duration: 1, // duration e.g. 1s
        ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
        stagger: 0.1, // delay e.g 0.1s
      };


      gsap.set( text, {autoAlpha: 0, y: 25} );
      gsap.set( cards, {autoAlpha: 0, y: 25} );
      gsap.set( images, {autoAlpha: 0, y: 25} );
      gsap.set( lines, {drawSVG: '0%'} );


      function treatmentHeroAnimations( textDelay, lineDelay, imagesDelay, cardsDelay ) {
        const tl = gsap.timeline();

        /* Text */
        tl.to( text, basicFade, textDelay );
        tl.to( text, basicSlideUp, textDelay );

        /* Lines */
        gsap.to( lines, {duration: 2, drawSVG: '100%'}, lineDelay );

        /* Images */
        tl.to( images, basicFade, imagesDelay );
        tl.to( images, basicSlideUp, imagesDelay );

        /* Cards */
        tl.to( cards, basicFade, cardsDelay );
        tl.to( cards, basicSlideUp, cardsDelay );
      }

      if ( $( '.treatment-hero' ).length ) {
        $( '.treatment-hero' ).each( function( index, element ) {
          ScrollTrigger.create( {
            trigger: $( element ),
            once: true,
            start: 'top 90%',
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
                  treatmentHeroAnimations( 0, 0.5, 0.9, 1.2 );
                } else {
                  treatmentHeroAnimations( 0, 0.5, 0.7, 0.5 );
                }
              }
            },
            onEnter: ( ) => {
              if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
                treatmentHeroAnimations( 0, 0.5, 0.9, 1.2 );
              } else {
                treatmentHeroAnimations( 0, 0.5, 0.7, 0.5 );
              }
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'treatment-hero', COMPONENT );
} )( app );
